import { render } from "./mycollect.vue?vue&type=template&id=60b0dea6&scoped=true"
import script from "./mycollect.vue?vue&type=script&lang=js"
export * from "./mycollect.vue?vue&type=script&lang=js"

import "./mycollect.vue?vue&type=style&index=0&id=60b0dea6&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b0dea6"]])

export default __exports__